// Module
var code = "<template>\n  <div class=\"tabs__tab__content\" show.bind=\"active\">\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;